const darkBlue = {
  10: '#13254A',
  50: '#253F7B',
  100: '#3657AD',
  200: '#4870DE',
}

export default darkBlue
